import type { ColumnDef } from '@/components/ui';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import { useApi } from '@/hooks/useApi';
import { sonarqubeApi } from '@/services/sonarqube-api';
import type { ISonarqubeProjectQualityHistory } from '@skystone/shared';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const sonarqubeQualityHistoryColumns: ColumnDef<ISonarqubeProjectQualityHistory>[] = buildRawColumns<ISonarqubeProjectQualityHistory>([
  { key: 'id', header: 'ID' },
  { key: 'projectKey', header: 'Project Key' },
  { key: 'metricKey', header: 'Metric Key' },
  { key: 'metricName', header: 'Metric Name' },
  { key: 'metricValue', header: 'Metric Value' },
  { key: 'metricGrade', header: 'Metric Grade' },
  { key: 'metricAt', header: 'Metric At' },
  { key: 'runId', header: 'Run ID' },
  { key: 'ingestionDate', header: 'Ingestion Date' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function TblSonarqubeQualityHistoryPage() {
  const { data: rows, loading, error } = useApi(() => sonarqubeApi.getQualityHistory({ limit: 500 }), []);

  if (loading && !rows) return <PageLoading />;

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - raw_fact_sonarqube_project_quality_history" subtitle={buildStandardTblSubtitle()} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={sonarqubeQualityHistoryColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('sonarqube quality history')}
      />
    </PageContainer>
  );
}
